// Types for LowFodmaps's own tables (schema `p_lowfodmaps`). Written by hand to match
// supabase/migrations/*_calma__*.sql and *_lowfodmaps__*.sql (the product was
// renamed from "calma"); regenerate once the schema grows:
//   supabase gen types typescript --project-id <ref> --schema p_lowfodmaps

export type Json = string | number | boolean | null | { [key: string]: Json | undefined } | Json[]

type Table<Row, Required extends keyof Row> = {
  Row: Row
  Insert: Pick<Row, Required> & Partial<Row>
  Update: Partial<Row>
  Relationships: []
}

type JourneyRow = {
  organization_id: string
  user_id: string
  phase: 'elimination' | 'reintroduction' | 'personalization'
  elimination_started_on: string | null
  health_consent_at: string | null
  created_at: string
  updated_at: string
}

type DiaryEntryRow = {
  id: string
  organization_id: string
  user_id: string
  entry_date: string
  meal: 'breakfast' | 'lunch' | 'dinner' | 'snack' | 'drink'
  body: string
  created_at: string
}

type SymptomLogRow = {
  organization_id: string
  user_id: string
  log_date: string
  score: number
  note: string
  updated_at: string
}

type ChallengeRow = {
  id: string
  organization_id: string
  user_id: string
  fodmap_group: string
  status: 'in_progress' | 'tolerated' | 'limited' | 'avoid'
  started_on: string
  days: Json
  note: string
  created_at: string
  updated_at: string
}

export type ProductDatabase = {
  p_lowfodmaps: {
    Tables: {
      journeys: Table<JourneyRow, 'organization_id' | 'user_id'>
      diary_entries: Table<DiaryEntryRow, 'organization_id' | 'user_id' | 'entry_date' | 'meal' | 'body'>
      symptom_logs: Table<SymptomLogRow, 'organization_id' | 'user_id' | 'log_date' | 'score'>
      challenges: Table<ChallengeRow, 'organization_id' | 'user_id' | 'fodmap_group'>
    }
    Views: Record<string, never>
    Functions: Record<string, never>
    Enums: Record<string, never>
    CompositeTypes: Record<string, never>
  }
}

export type Journey = JourneyRow
export type DiaryEntry = DiaryEntryRow
export type SymptomLog = SymptomLogRow
export type Challenge = ChallengeRow
export type Meal = DiaryEntryRow['meal']
export const MEALS: readonly Meal[] = ['breakfast', 'lunch', 'dinner', 'snack', 'drink']
